var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareButtonBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.23,
    height: 73.23,
    viewBox: "0 0 73.23 73.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_2_",
    "data-name": "share (2)",
    transform: "translate(-0.004 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9050",
    "data-name": "Path 9050",
    d: "M182.286,21.3,162.452.7a2.289,2.289,0,0,0-3.936,1.59v9.917h-.763A29.784,29.784,0,0,0,128,41.956v4.577a2.258,2.258,0,0,0,1.782,2.188,2.044,2.044,0,0,0,.5.061,2.367,2.367,0,0,0,2.09-1.3,25.028,25.028,0,0,1,22.512-13.914h3.625v9.916a2.289,2.289,0,0,0,3.936,1.587l19.833-20.6A2.289,2.289,0,0,0,182.286,21.3Zm0,0",
    transform: "translate(-109.692)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9051",
    "data-name": "Path 9051",
    d: "M64.08,146.365H9.158A9.165,9.165,0,0,1,0,137.211V94.494A9.165,9.165,0,0,1,9.158,85.34h9.154a3.051,3.051,0,1,1,0,6.1H9.158a3.053,3.053,0,0,0-3.052,3.052v42.717a3.053,3.053,0,0,0,3.052,3.052H64.08a3.053,3.053,0,0,0,3.051-3.052V112.8a3.051,3.051,0,1,1,6.1,0v24.41A9.165,9.165,0,0,1,64.08,146.365Zm0,0",
    transform: "translate(0 -73.134)",
    fill: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareButtonBlack);
export default __webpack_public_path__ + "static/media/share_button_black.cefea839e200fd1e1fea26cea48d5fdf.svg";
export { ForwardRef as ReactComponent };